<template>
  <div>
    <!-- :before-close="handleClose" -->
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      size="600px"
      :wrapperClosable="false"
    >
      <div class="form-center" v-loading="loading">
        <el-form :model="form" ref="form" label-width="120px" :rules="rules">
          <!-- <el-form-item label="头像" prop="HeadImg" class="Describe">
            <el-upload
              class="avatar-uploader"
              :action="$rootUrl + `/Base_Manage/Upload/UploadFileByForm`"
              :headers="{
                Authorization: token,
              }"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <el-image
                v-if="form.HeadImg"
                fit="contain"
                class="HeadImg"
                :src="form.HeadImg"
              ></el-image>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item> -->
          <el-form-item label="备件编号" prop="Code">
            <el-input
              v-model="form.Code"
              placeholder="请输入备件编号"
            ></el-input>
          </el-form-item>
          <el-form-item label="备件名称" prop="Name">
            <el-input
              v-model="form.Name"
              placeholder="请输入备件名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="备件规格" prop="Spec">
            <el-input
              v-model="form.Spec"
              placeholder="请输入备件规格"
            ></el-input>
          </el-form-item>

          <el-form-item label="备件类型" prop="MaterialTypeId">
            <el-cascader
              style="width: 100%"
              filterable
              v-model="form.MaterialTypeId"
              :options="OptionsTree"
              :props="{
                emitPath: false,
                expandTrigger: 'hover',
                checkStrictly: true,
                children: 'children',
                label: 'title',
                value: 'Id',
              }"
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item label="单位" prop="storageName">
            <div style="width: 100%; display: flex; align-items: center">
              <el-input
                v-model="form.storageName"
                placeholder="请选择单位组"
                disabled
                style="width: calc(100% - 60px)"
              ></el-input>
              <el-button
                style="width: 60px"
                type="primary"
                @click="openMeasuringunit"
                ><i class="el-icon-search"></i
              ></el-button>
            </div>
            <!-- <el-input v-model="form.UnitGroupId" placeholder="请输入备件名称"></el-input> -->
          </el-form-item>
          <!-- <el-form-item label="单位" prop="storageName">
            <div style="width: 100%; display: flex; align-items: center">
              <el-input
                v-model="form.storageName"
                placeholder="请选择单位"
                disabled
                style="width: calc(100% - 60px)"
              ></el-input>
              <el-button
                style="width: 60px"
                type="primary"
                @click="openMeasuringunitGroup"
                ><i class="el-icon-search"></i
              ></el-button>
            </div>
          </el-form-item> -->
          <el-form-item label="厂家" prop="Manufacturer">
            <el-input
              v-model="form.Manufacturer"
              placeholder="请输入厂家名称"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="状态" prop="UsageStatus">
            <el-input v-model="form.UsageStatus" placeholder="请输入备件名称"></el-input>
            <el-radio-group v-model="form.UsageStatus">
              <el-radio :label="true">启用</el-radio>
              <el-radio :label="false">停用</el-radio>
            </el-radio-group>
          </el-form-item> -->
          <el-form-item label="备注" prop="Remarks">
            <el-input
              v-model="form.Remarks"
              placeholder=""
              type="textarea"
              rows="3"
              resize="none"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="货区类型">
            <SelectDicValue
              ref="SelectDicValue"
              code="StorAreaType"
              v-model="form.Type"
            ></SelectDicValue>
          </el-form-item> -->
          <!-- <el-form-item label="性别" prop="Sex">
            <el-radio-group v-model="form.Sex">
              <el-radio :label="0">女</el-radio>
              <el-radio :label="1">男</el-radio>
            </el-radio-group>
          </el-form-item> -->

          <!-- <el-form-item label="所属角色">
            <el-select
              v-model="form.RoleIdList"
              placeholder="请选择角色"
              multiple
              filterable
            >
              <el-option
                v-for="item in OptionsTree"
                :key="item.Id"
                :value="item.Id"
                :label="item.RoleName"
                >{{ item.RoleName }}</el-option
              >
            </el-select>
          </el-form-item> -->
        </el-form>
      </div>
      <div class="footer" v-loading="loading">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handleSubmit">保存</el-button>
      </div>
    </el-drawer>
    <Measuringunit
      ref="Measuringunit"
      type="radio"
      @select="handleUnit"
    ></Measuringunit>
    <!-- <MeasuringunitGroup
      ref="MeasuringunitGroup"
      type="radio"
      @select="handleUnitGroup"
    ></MeasuringunitGroup> -->
  </div>
</template>
<script>
import SelectDicValue from '@/components/DicValue/SelectDicValue.vue'
import Measuringunit from '@/components/Measuringunit/Measuringunit.vue'
// import MeasuringunitGroup from "@/components/Measuringunit/MeasuringunitGroup.vue";

import Token from '@/utils/cache/TokenCache.js'
export default {
  data() {
    return {
      title: '',
      loading: false,
      token: 'Bearer ' + Token.getToken(),
      OptionsTree: [],
      form: {
        Code: '',
        Name: '',
        Spec: '',
        MaterialTypeId: '',
        UnitGroupId: '',
        UnitGroupName: '',
        storageId: '',
        storageName: '',
        Manufacturer: '',
        Remarks: '',
        // HeadImg: "",
        // UserCode: "",
        // UserName: "",
      },
      rules: {
        Code: [{ required: true, message: '请输入备件编号', trigger: 'blur' }],
        Name: [{ required: true, message: '请输入备件名称', trigger: 'blur' }],
        Spec: [{ required: true, message: '请输入备件规格', trigger: 'blur' }],
        MaterialTypeId: [
          { required: true, message: '请输入备件类型', trigger: 'blur' },
        ],
        UnitGroupName: [
          { required: true, message: '请选择单位组', trigger: 'change' },
        ],
        storageName: [
          { required: true, message: '请选择单位', trigger: 'change' },
        ],
        // Manufacturer: [{ required: true, message: "请输入厂家", trigger: "blur" }],
        // Remarks: [{ required: true, message: "请输入备注", trigger: "blur" }],
      },
      drawer: false,
    }
  },
  props: {},
  components: {
    Measuringunit,
    // MeasuringunitGroup
  },
  methods: {
    // handleUnitGroup(rows) {
    //   console.log(rows);
    //   this.$set(this.form, "storageId", rows[0].Id);
    //   this.$set(this.form, "storageName", rows[0].UnitName);
    // },
    handleUnit(rows) {
      console.log(rows)
      this.$set(this.form, 'storageId', rows[0].Id)
      this.$set(this.form, 'storageName', rows[0].UnitName)
    },
    openMeasuringunit() {
      this.$refs.Measuringunit.openDialog()
    },
    openMeasuringunitGroup() {
      this.$refs.MeasuringunitGroup.openDialog(this.form.UnitGroupId)
    },

    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 20

      if (!isJPG) {
        this.$notify.error('上传图片只能是 JPG 或 PNG 格式!')
      }
      if (!isLt2M) {
        this.$notify.error('上传头像图片大小不能超过 20MB!')
      }
      return isJPG && isLt2M
    },
    handleAvatarSuccess(res) {
      console.log(res, 'res')
      if (res.status == 'done') {
        this.form.HeadImg = res.url

        console.log(this.form.HeadImg)
      } else {
        this.$notify.error(res.Msg)
      }
    },
    getOptionsTree() {
      this.$http.post('/PB/PB_MaterialType/GetTreeDataList').then((resJson) => {
        if (resJson.Success) {
          this.OptionsTree = resJson.Data
        }
      })
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return this.$notify.error('请检查输入项')
        }
        this.loading = true
        this.$http
          .post('/PB/PB_Material/SaveData', this.form)
          .then((resJson) => {
            this.loading = false

            if (resJson.Success) {
              this.$notify.success('操作成功!')
              this.$emit('success')
              this.close()
            } else {
              this.$notify.error(resJson.Msg)
            }
          })
      })
    },
    openForm(title, row = {}) {
      this.drawer = true
      this.getOptionsTree()
      this.form = {
        Code: '',
        Name: '',
        Spec: '',
        MaterialTypeId: '',
        UnitGroupId: '',
        UnitGroupName: '',
        storageId: '',
        storageName: '',
        Manufacturer: '',
        Remarks: '',
      }
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
      this.title = title
      if (row.Id) {
        this.getInfo(row.Id)
      }
    },
    getInfo(id) {
      this.loading = true
      this.$http
        .post('/PB/PB_Material/GetTheData', { id: id })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.form = resJson.Data
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    close() {
      this.drawer = false
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__header {
  margin: 0;
  padding: 20px;
}
.form-center {
  height: calc(100vh - 120px);
  padding: 20px;
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 20px;
}
::v-deep .avatar-uploader .el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 65px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
</style>
